import React from 'react';
// import get from 'lodash/get';

class Wrapper extends React.Component {
  // constructor(props) {
  //   super(props);
  //
  //   this.state = {
  //     backgroundColor: false,
  //     color: false,
  //   }
  // }

  render() {
    const { color } = this.props;
    const backgroundColor = color ? '#ffffff' : false;

    return (
      <div
        className="wrapper"
        style={{
          backgroundColor,
          color,
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

export default Wrapper;



// WEBPACK FOOTER //
// ./src/components/Wrapper.js